import React from 'react';
import '../../styles-v2/onboarding/v2-onboarding-steps.css';
import { getStepIcon } from './data/OnboardingData';

const StepCards = ({ steps, activeStep, onStepClick }) => {
  return (
    <div className="v2-step-cards">
      {steps.map((step) => (
        <div
          key={step.id}
          className={`v2-step-card ${
            step.id === activeStep ? 'v2-step-card--active' : ''
          } ${step.id < activeStep ? 'v2-step-card--completed' : ''}`}
          onClick={() => onStepClick && onStepClick(step.id)}
          style={{ cursor: onStepClick ? 'pointer' : 'default' }}
        >
          <div className="v2-step-card__number">{step.id}</div>
          <div className="v2-step-card__content">
            <div className="v2-step-card__icon">{getStepIcon(step.id)}</div>
            <div className="v2-step-card__text">
              <h3 className="v2-step-card__title">{step.title}</h3>
              <p className="v2-step-card__subtitle">{step.subtitle}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StepCards;
